(function () {
	'use strict';
	angular.module('app.core')
		.directive('sharedViewOwner', sharedViewOwner);

	sharedViewOwner.$inject = [];
	function sharedViewOwner() {
		return {
			restrict: 'E',
			templateUrl: '/application/f/core/directives/shared-view-owner.html',
			controller: sharedViewOwnerCtrl,
			controllerAs: 'sharedViewOwnerCtrl',
			bindToController: true
		};
	}

	sharedViewOwnerCtrl.$inject = ['$scope', 'storeService'];
	function sharedViewOwnerCtrl($scope, storeService) {
		var vm = this;
		var unsubscribe;
		unsubscribe = storeService.subscribe(function () {
			var state = storeService.getState();
			var reportSettings = state.reportSettings;
			vm.parentUser = reportSettings.parentUserNdx !== globalConfig.user.id && reportSettings.parentUser;
		});

		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});
	}
})();